import axios from "axios";
import Cookies from "js-cookie";
import {
  onRegistration,
  onTrialPurchased,
  onRegularFreeTrialActions
} from "@/scripts/helpers/googleAnalyticsEvents";
import MicroModal from "micromodal";
import {
  initLoader,
  hideLoader
} from "@/modules/loader/loader";

export default () => {
  const googleOneTap = $(".google-one-tap");
  const googleOneTapForm = $(".google-one-tap-forms");
  const token = $("meta[name='csrf-token']").attr("content");
  const pageUrl = window.location.href;

  // exp-18450
  const body = $("body");
  const tabletBreakpoint = 959;
  const exp18450 = $(".exp-18450");
  const googleOtButton = $(".google-button");
  const gWithText = $(".g-with-text");
  const gWithTextAndDontHidden = $(".g-with-text-and-dont-hidden");
  const gWithTextAndDontHiddenBody = $(".g-with-dont-hidden-window-one-tap");
  const dontHiddenWindowOneTap = $(".dont-hidden-window-one-tap");

  const oneTapShow = () => {
    Cookies.remove("g_state");
    google.accounts.id.prompt((notification) => {
      if (notification.isSkippedMoment() && notification.getSkippedReason() === 'user_cancel') {
        googleOtButton.removeClass("alternative-one-tap-spin");

        if ($(".alternative-one-tap-active-v1").length) {
          body.removeClass("alternative-one-tap-active-v1");
        }
        if ($(".alternative-one-tap-active-v2").length) {
          body.removeClass("alternative-one-tap-active-v2");
        }
        if (!$(".alternative-one-tap-show").length) {
          setTimeout(() => {
            body.addClass("alternative-one-tap-show");
          }, 900);
        }
      }
      if (notification.isDisplayMoment() || notification.isDisplayed()) {
        setTimeout(() => {
          body.removeClass("alternative-one-tap-show");
        }, 900);
      }
    });
  };
  // exp-18450

  if (googleOneTap.length) {
    window.onload = function() {
      Cookies.remove("g_state");
      const clientID =
        process.env.NODE_ENV === "production"
          ? "503458506158-ik55q8icsg2icen0t4qkr6a7uucoknug.apps.googleusercontent.com"
          : "799622306347-f6ahms0p90ub7o0cb2geqavlulinqr7d.apps.googleusercontent.com";

      if (dontHiddenWindowOneTap.length || gWithTextAndDontHiddenBody.length) {
        google.accounts.id.initialize({
          client_id: clientID,
          callback: handleCredentialResponse,
          cancel_on_tap_outside: false
        });
      } else {
        google.accounts.id.initialize({
          client_id: clientID,
          callback: handleCredentialResponse
        });
      }

      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {

          // The detailed reason why the UI isn't displayed.
          var detailedNotDisplayedReason = notification.getNotDisplayedReason();

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-not-displayed`,
            data: {
              login_status: "isNotDisplayed",
              page_url: pageUrl,
              not_displayed_reason: detailedNotDisplayedReason
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });

          // exp-18450
          const isDisplayedOneTap = $(".is-displayed-one-tap");

          if (exp18450.length && $(window).width() > tabletBreakpoint && isDisplayedOneTap.length) {
            setTimeout(() => {
              body.addClass("alternative-one-tap-show");
            }, 600);

            gWithText.hover( function(e){
              const alternativeOneTapActiveV1 = $(".alternative-one-tap-active-v1");
              if (!alternativeOneTapActiveV1.length) {
                oneTapShow();
                setTimeout(() => {
                  googleOtButton.addClass("alternative-one-tap-spin");
                }, 900);

                axios({
                  method: "post",
                  url: `/api/v1/metrics/google-one-tap-alternative-show-v1`,
                  data: {
                    login_status: "alternativeOneTapShowV1",
                    page_url: pageUrl
                  },
                  dataType: "json",
                  headers: { "X-CSRF-TOKEN": token},
                  withCredentials: false
                });
                e.preventDefault();
              };
              
              body.addClass("alternative-one-tap-active-v1");
            });

            gWithTextAndDontHidden.hover( function(e){
              const alternativeOneTapActiveV2 = $(".alternative-one-tap-active-v2");
              if (!alternativeOneTapActiveV2.length) {
                oneTapShow();
                setTimeout(() => {
                  googleOtButton.addClass("alternative-one-tap-spin");
                }, 900);

                axios({
                  method: "post",
                  url: `/api/v1/metrics/google-one-tap-alternative-show-v2`,
                  data: {
                    login_status: "alternativeOneTapShowV2",
                    page_url: pageUrl
                  },
                  dataType: "json",
                  headers: { "X-CSRF-TOKEN": token},
                  withCredentials: false
                });
                e.preventDefault();
              };
              
              body.addClass("alternative-one-tap-active-v2");
            });
          }
          // exp-18450

        } else {
          // exp-18450
          body.addClass("is-displayed-one-tap");
          // exp-18450

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-show`,
            data: {
              login_status: "isDisplayed",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        }
      });
    };

    function handleCredentialResponse(data) {
      axios({
        method: "post",
        url: `/api/v1/metrics/google-one-tap-click`,
        data: {
          login_status: true,
          page_url: pageUrl
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token},
        withCredentials: false
      });

      // exp-18450
      const alternativeBtnActiveV1 = $(".alternative-one-tap-active-v1");
      const alternativeBtnActiveV2 = $(".alternative-one-tap-active-v2");

      if (alternativeBtnActiveV1.length) {
        axios({
          method: "post",
          url: `/api/v1/metrics/google-one-tap-alternative-active-v1`,
          data: {
            login_status: true,
            page_url: pageUrl
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token},
          withCredentials: false
        });
      };
      if (alternativeBtnActiveV2.length) {
        axios({
          method: "post",
          url: `/api/v1/metrics/google-one-tap-alternative-active-v2`,
          data: {
            login_status: true,
            page_url: pageUrl
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token},
          withCredentials: false
        });
      };
      // exp-18450

      initLoader($(".exp-18121"));

      const pathDomain =
        process.env.NODE_ENV === "production"
          ? ".signnow.com"
          : ".signnow-dev.xyz";

      Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

      const path =
        process.env.NODE_ENV === "production"
          ? "https://app.signnow.com/auth/v1/sessions/social"
          : "https://app3.signnow-dev.xyz/auth/v1/sessions/social";

      axios
        .post(
          path,
          {
            token: data.credential,
            provider: "google",
            login_source: "signnow_one_tap"
          },
          { withCredentials: true }
        )
        .then(res => {
          if (res.data.social_reg) {
            onRegistration();
            onTrialPurchased();
            onRegularFreeTrialActions("Google One Tap", "Sign-up");
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Sign-up"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          } else if (res.data.social_reg === false) {
            onRegularFreeTrialActions("Google One Tap", "Login");
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Login"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          }

          const pathUrl =
            process.env.NODE_ENV === "production"
              ? "https://app.signnow.com/webapp/folder"
              : "https://app3.signnow-dev.xyz/webapp/folder";

          window.location.href = pathUrl;
        })
        .catch(error => {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-fail`,
            data: {
              login_status: false,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        });
    }
  }

  if (googleOneTapForm.length) {
    window.onload = function() {
      Cookies.remove("g_state");
      const clientID =
        process.env.NODE_ENV === "production"
          ? "503458506158-ik55q8icsg2icen0t4qkr6a7uucoknug.apps.googleusercontent.com"
          : "799622306347-f6ahms0p90ub7o0cb2geqavlulinqr7d.apps.googleusercontent.com";

      if (dontHiddenWindowOneTap.length || gWithTextAndDontHiddenBody.length) {
        google.accounts.id.initialize({
          client_id: clientID,
          callback: handleCredentialResponse,
          cancel_on_tap_outside: false
        });
      } else {
        google.accounts.id.initialize({
          client_id: clientID,
          callback: handleCredentialResponse
        });
      }
      google.accounts.id.prompt((notification) => {        
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // The detailed reason why the UI isn't displayed.
          var detailedNotDisplayedReason = notification.getNotDisplayedReason();

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-not-displayed`,
            data: {
              login_status: "isNotDisplayedOnForms",
              page_url: pageUrl,
              not_displayed_reason: detailedNotDisplayedReason
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });

          // exp-18450  
          const isDisplayedOneTap = $(".is-displayed-one-tap");

          if (exp18450.length && $(window).width() > tabletBreakpoint && isDisplayedOneTap.length) {
            setTimeout(() => {
              body.addClass("alternative-one-tap-show");
            }, 600);

            gWithText.hover( function(e){
              const alternativeOneTapActiveV1 = $(".alternative-one-tap-active-v1");
              if (!alternativeOneTapActiveV1.length) {
                oneTapShow();
                setTimeout(() => {
                  googleOtButton.addClass("alternative-one-tap-spin");
                }, 900);

                axios({
                  method: "post",
                  url: `/api/v1/metrics/google-one-tap-alternative-show-forms-v1`,
                  data: {
                    login_status: "alternativeOneTapShowFormsV1",
                    page_url: pageUrl
                  },
                  dataType: "json",
                  headers: { "X-CSRF-TOKEN": token},
                  withCredentials: false
                });
                e.preventDefault();
              };
              
              body.addClass("alternative-one-tap-active-v1");
            });

            gWithTextAndDontHidden.hover( function(e){
              const alternativeOneTapActiveV2 = $(".alternative-one-tap-active-v2");
              if (!alternativeOneTapActiveV2.length) {
                oneTapShow();
                setTimeout(() => {
                  googleOtButton.addClass("alternative-one-tap-spin");
                }, 900);

                axios({
                  method: "post",
                  url: `/api/v1/metrics/google-one-tap-alternative-show-forms-v2`,
                  data: {
                    login_status: "alternativeOneTapShowFormsV2",
                    page_url: pageUrl
                  },
                  dataType: "json",
                  headers: { "X-CSRF-TOKEN": token},
                  withCredentials: false
                });
                e.preventDefault();
              };
              
              body.addClass("alternative-one-tap-active-v2");
            });
          }
          // exp-18450

        } else {
          // exp-18450
          body.addClass("is-displayed-one-tap");
          // exp-18450

          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-show`,
            data: {
              login_status: "isDisplayedOnForms",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        }
      });
    };

    function handleCredentialResponse(data) {
      axios({
        method: "post",
        url: `/api/v1/metrics/google-one-tap-forms-click`,
        data: {
          login_status: true,
          page_url: pageUrl
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token},
        withCredentials: false
      });

      // exp-18450
      const alternativeBtnActiveV1 = $(".alternative-one-tap-active-v1");
      const alternativeBtnActiveV2 = $(".alternative-one-tap-active-v2");

      if (alternativeBtnActiveV1.length) {
        axios({
          method: "post",
          url: `/api/v1/metrics/google-one-tap-alternative-active-forms-v1`,
          data: {
            login_status: true,
            page_url: pageUrl
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token},
          withCredentials: false
        });
      };
      if (alternativeBtnActiveV2.length) {
        axios({
          method: "post",
          url: `/api/v1/metrics/google-one-tap-alternative-active-forms-v2`,
          data: {
            login_status: true,
            page_url: pageUrl
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token},
          withCredentials: false
        });
      };
      // exp-18450

      initLoader($(".exp-18121"));

      const pathDomain =
        process.env.NODE_ENV === "production"
          ? ".signnow.com"
          : ".signnow-dev.xyz";

      Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

      const path =
        process.env.NODE_ENV === "production"
          ? "https://app.signnow.com/auth/v1/sessions/social"
          : "https://app3.signnow-dev.xyz/auth/v1/sessions/social";

      axios
        .post(
          path,
          {
            token: data.credential,
            provider: "google",
            login_source: "pdffiller_one_tap"
          },
          { withCredentials: true }
        )
        .then(res => {
          if (res.data.social_reg) {
            onRegistration();
            onTrialPurchased();
            onRegularFreeTrialActions("Google One Tap", "Sign-up");
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Sign-up"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          } else if (res.data.social_reg === false) {
            onRegularFreeTrialActions("Google One Tap", "Login");
            axios({
              method: "post",
              url: `/event/google-one-tap-login-event`,
              data: {
                login_status: true,
                page_url: pageUrl,
                auth_type: "Login"
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          }

          const formId = $(
            ".page-section--greeting, .page-section--intro"
          ).attr("data-formId");
          
          const formLoader = () => {
            $.ajax({
              url: "/forms/get-editor-data",
              type: "POST",
              data: {
                id: formId
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token },

              success: function(data) {
                let editorUrl = data.editorUrl;
                setTimeout(() => {
                  window.location.href = editorUrl;
                }, 700);
              }
            });
          };

          $(".modal__button--back").click(function(e) {
            e.preventDefault();

            $.ajax({
              url: "/forms/get-editor-data",
              type: "POST",
              data: {
                id: formId
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token },
              success: function(data) {
                let editorUrl = data.editorUrl;

                setTimeout(() => {
                  window.open(editorUrl, "_blank");
                }, 700);
              }
            });
          });

          $(".modal__button--check").click(function(e) {
            axios({
              method: "post",
              url: `/api/v1/metrics/google-one-tap-popup-signnow`,
              data: {},
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          });

          if ($("#modal-registration").length) {
            MicroModal.show("modal-registration");
            hideLoader($(".exp-18121"));
          } else {
            formLoader();
          }
        })
        .catch(error => {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-fail`,
            data: {
              login_status: false,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        });
    }
  }
};
